// Типы для управления маршрутами
import { z } from "zod";
import { zRouteStatusSchema } from "./route.common";
const zRouteEmployeeRefSchema = z
    .object({
    firstName: z.string(),
    lastName: z.string().nullish(),
})
    .nullish();
// Route схема
export const zRouteSchemaDom = z.object({
    id: z.string(),
    idTechnician: z.string(),
    idServiceVehicle: z.string().nullable(),
    idChargingStation: z.string().nullable(),
    plannedStartTime: z.string(),
    expectedArrivalTime: z.string().nullable(),
    status: zRouteStatusSchema,
    createdAt: z.string().nullish(),
    updatedAt: z.string().nullish(),
    createdBy: zRouteEmployeeRefSchema,
    updatedBy: zRouteEmployeeRefSchema,
});
